module.exports = __webpack_public_path__ + "static/media/azure.01cd95b4.png";